import React from 'react';
import { useTimerStore } from '../../stores/timerStore';
import { UserBadge } from './UserBadge';
import { LogoWithKonami } from './LogoWithKonami';
import type { Direction } from '../../hooks/useKonamiCode';

interface HeaderProps {
  showRoomInfo?: boolean;
  onDirectionClick?: (dir: Direction) => void;
  progressLength?: number;
}

export function Header({ showRoomInfo = false, onDirectionClick, progressLength }: HeaderProps) {
  const { currentRoom, isConnected, participants } = useTimerStore();
  const onlineCount = Object.values(participants).filter((p) => p.online).length;

  return (
    <header className="sticky top-0 z-10 backdrop-blur-xl bg-namm-bg/80 border-b border-namm-line/40">
      <div className="max-w-7xl mx-auto px-5 py-4 flex items-center justify-between gap-4">
        {/* Brand with Konami Logo */}
        <LogoWithKonami
          onDirectionClick={onDirectionClick}
          progressLength={progressLength}
        />

        {/* Room Info */}
        {showRoomInfo && currentRoom && (
          <div className="flex items-center gap-4 text-xs font-mono">
            <span className="text-namm-muted uppercase tracking-widest">
              {currentRoom.name}
            </span>
            <span className="text-namm-cyan tracking-widest">
              [{currentRoom.code}]
            </span>
            <span className="text-namm-muted">
              {onlineCount} en ligne
            </span>
          </div>
        )}

        {/* Right side */}
        <div className="flex items-center gap-4">
          {/* Connection indicator */}
          <div className="flex items-center gap-2 text-xs font-mono">
            <div
              className={`w-2 h-2 rounded-full ${
                isConnected ? 'bg-green-400 shadow-[0_0_6px_rgba(74,222,128,0.6)]' : 'bg-namm-danger shadow-[0_0_6px_rgba(255,59,59,0.6)]'
              }`}
            />
            <span className="text-namm-muted hidden sm:inline">
              {isConnected ? 'Connecté' : 'Déconnecté'}
            </span>
          </div>

          <UserBadge />
        </div>
      </div>
    </header>
  );
}
